import { Question } from "../types";

export function isQuestionFlagged(question: Question): boolean {
  return (
    (question.flaggedBy?.length ?? 0) > 0 ||
    (question.flaggedComments?.length ?? 0) > 0
  );
}

export function getFlagFeedback(question: Question): string | undefined {
  const fromBy = question.flaggedBy?.find(
    (f) => f.comment?.trim() || f.text?.trim(),
  );
  if (fromBy) {
    return (fromBy.comment || fromBy.text)?.trim();
  }

  const fromComments = question.flaggedComments?.find((c) => c.text?.trim());
  return fromComments?.text?.trim();
}
